import {  BoundingBoxAnchorResult, ClaimReferenceAnchorResult } from "@shared/models/common";

export class ClaimReferenceDetails {

  refPhraseText!: string;
  refDocId!: number;
  anchors?: (BoundingBoxAnchorResult | ClaimReferenceAnchorResult)[];
  isConsistencyGenerated?: boolean;
  alreadyExists: boolean = false



}